export default "__VITE_ASSET__DV9Fdr6S__"